import { makeStyles } from '@material-ui/core'
import { INFO_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(() => ({
  tabsContainer: {
    marginBottom: 12
  },
  tabs: {
    '& .Mui-selected': { color: INFO_COLORS[700] },
    '& .MuiTabs-indicator': { backgroundColor: INFO_COLORS[700] }
  }
}))
